// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getSubCategory = createAsyncThunk('subCategorySlice/getSubCategory', async () => {
    try {
        let response = await axios.get('/SubCategory', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const createSubCategory = createAsyncThunk('subCategorySlice/createSubCategory', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/SubCategory', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Taxmaster added succesfully.');
        await dispatch(getSubCategory());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateSubCategory = createAsyncThunk('subCategorySlice/updateSubCategory', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/SubCategory/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Taxmaster updated succesfully.');
        await dispatch(getSubCategory());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const deleteSubCategory = createAsyncThunk('subCategorySlice/deleteSubCategory', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/SubCategory/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Taxmaster deleted successfully.');
        await dispatch(getSubCategory());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateSubCategoryStatus = createAsyncThunk('subCategorySlice/updateSubCategoryStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/SubCategory/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getSubCategory());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const subCategorySlice = createSlice({
    name: 'subCategorySlice',
    initialState: {
        subCategory: []
    },
    extraReducers: (builder) => {
        builder.addCase(getSubCategory.fulfilled, (state, action) => {
            state.subCategory = action?.payload;
            return;
        });
    }
});

export default subCategorySlice.reducer;
